// src/app/app.config.ts
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import Aura from '@primeng/themes/aura';
import Material from '@primeng/themes/material';
import Lara from '@primeng/themes/lara';
import Nora from '@primeng/themes/nora';

import { routes } from './app.routes';
import {
  provideHttpClient,
  withInterceptors,
  withJsonpSupport,
} from '@angular/common/http';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { progressInterceptor } from 'ngx-progressbar/http';
import { DecimalPipe } from '@angular/common';
import { provideTablerIcons } from 'angular-tabler-icons';
import {
  IconNumber123,
  IconAdOff,
  IconHeartFilled,
  IconCamera,
  IconPinInvoke,
  IconNumber,
} from 'angular-tabler-icons/icons';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(),
    provideAngularSvgIcon(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none',
        },
      },
    }),
    // https://github.com/MurhafSousli/ngx-progressbar/blob/master/projects/ngx-progressbar/docs/HttpClient-requests.md
    provideHttpClient(
      withJsonpSupport(),
      withInterceptors([progressInterceptor])
    ),
    MessageService,
    DecimalPipe,
    provideTablerIcons({
      IconNumber123,
      IconAdOff,
      IconHeartFilled,
      IconCamera,
      IconPinInvoke,
      IconNumber,
    }),
  ],
};
